var _defs, _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack403({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.5,
    y: 3.63,
    width: 15,
    height: 8.74
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2.24,9.52V5.58H3.36A2,2,0,0,1,4,5.65,1,1,0,0,1,4.47,6a1.58,1.58,0,0,1,.32.62,3.09,3.09,0,0,1,.12.91,2.93,2.93,0,0,1-.2,1.13,1.35,1.35,0,0,1-.5.66,1.46,1.46,0,0,1-.8.2Zm.43-.47h.69A1.23,1.23,0,0,0,4,8.92a.9.9,0,0,0,.33-.44,2.76,2.76,0,0,0,.15-1,2.21,2.21,0,0,0-.16-.94.91.91,0,0,0-.42-.46A1.45,1.45,0,0,0,3.34,6H2.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.15,9.52,6.4,5.58h.45L8.18,9.52H7.69l-.38-1.2H6L5.6,9.52ZM6.08,7.9h1.1L6.84,6.81c-.1-.34-.18-.61-.23-.82a6.27,6.27,0,0,1-.17.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.8,8.13l.43.14a1.85,1.85,0,0,1-.49,1,1.28,1.28,0,0,1-.87.32,1.32,1.32,0,0,1-.77-.22,1.57,1.57,0,0,1-.52-.7,3,3,0,0,1-.2-1.14,2.74,2.74,0,0,1,.2-1.1,1.58,1.58,0,0,1,.55-.68,1.33,1.33,0,0,1,.78-.23,1.19,1.19,0,0,1,.8.29,1.6,1.6,0,0,1,.47.85l-.42.12C10.62,6.23,10.33,6,9.9,6a1,1,0,0,0-.56.16A1.14,1.14,0,0,0,9,6.63a2.52,2.52,0,0,0-.14.89A2.18,2.18,0,0,0,9.1,8.73a.9.9,0,0,0,.76.41.84.84,0,0,0,.6-.25A1.31,1.31,0,0,0,10.8,8.13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.6,9.52V6H11.53V5.58h2.56V6H13V9.52Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack403);
export default __webpack_public_path__ + "static/media/Symbol_pack_403.eef3cac1e7de8f3fa8dc4162a1135acb.svg";
export { ForwardRef as ReactComponent };